import React, { Component } from "react";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { formValueSelector } from "redux-form";
import { connect } from "react-redux";
import * as actions from "MODULES/parts/actions";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import {
  calculateValue,
  conversionUnit,
  conversionUnitAbbrev
} from "LIB/formatters/weight";
import {
  HEIGHT,
  LENGTH,
  WEIGHT,
  WEIGHT_UNIT,
  WIDTH
} from "MODULES/parts/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import NetWeightAndDimsFormRow from "MODULES/shared/components/Forms/NetWeightAndDimsFormRow/NetWeightAndDimsFormRow";
import CentimeterDimensions from "../shared/CentimeterDimensions";
import Dimensions from "../shared/Dimensions";
import validate from "./validate";
import Weight from "../shared/Weight";

const EDIT_DIMENSIONS_FORM = "editDimensions";

export class DimensionsForm extends Component {
  state = {
    checkingForDuplicates: false,
    hasDuplicates: false
  };

  render() {
    const { getField, width, height, length, weight, unit } = this.props;

    return (
      <AppForm {...this.props}>
        <AppForm.Body>
          <h4>Gross (Package) Weight & Dims</h4>
          <FormRow>
            <Col md={3}>
              <Weight />
            </Col>
            <Col md={2}>
              <label className="control-label" htmlFor="read_only_conversion">
                {conversionUnit(unit)}
              </label>
              <div className="input-group">
                <input
                  name="read_only_conversion"
                  className="form-control"
                  type="text"
                  value={calculateValue(unit, weight)}
                  disabled
                  readOnly
                />
                <span className="input-group-addon">
                  {conversionUnitAbbrev(unit)}
                </span>
              </div>
            </Col>
            <Col md={4}>
              <Dimensions />
            </Col>
            <Col md={3}>
              <CentimeterDimensions
                width={width}
                height={height}
                length={length}
              />
            </Col>
          </FormRow>
          <hr className="hr-xs hr-dashed" />
          <NetWeightAndDimsFormRow getField={getField} />
        </AppForm.Body>
      </AppForm>
    );
  }
}

DimensionsForm.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  length: PropTypes.number,
  unit: PropTypes.string,
  weight: PropTypes.number,
  net_width: PropTypes.number,
  net_height: PropTypes.number,
  net_length: PropTypes.number,
  net_weight: PropTypes.number,
  net_weight_unit: PropTypes.string
};

const selector = formValueSelector(EDIT_DIMENSIONS_FORM);

export default connect(
  state => ({
    getField: field => selector(state, field),
    unit: selector(state, WEIGHT_UNIT),
    ...[WIDTH, HEIGHT, LENGTH, WEIGHT].reduce(
      (prev, current) => ({
        ...prev,
        [current]: selector(state, current)
      }),
      {}
    )
  }),
  { onSubmit: actions.update, search: actions.searchMatchingPartNumbers }
)(
  form({
    form: EDIT_DIMENSIONS_FORM,
    validate
  })(DimensionsForm)
);



// WEBPACK FOOTER //
// ./app/modules/parts/components/EditPart/DimensionsForm.jsx